import { Injectable } from '@angular/core';
import { AuthServerProvider, EventManager } from 'src/app/core';
import HelperUtil from 'src/app/shared/util/helper-util';
import { FileUploader } from 'ng2-file-upload';
import { environment } from 'src/environments/environment';
@Injectable()
export class UploaderService {
    uploader: FileUploader;
    allowedMimeType = [];
    isErrorUpload: boolean = false;
    broadcast: string = 'no-name';
    constructor(
        private authServerProvider: AuthServerProvider,
        private eventManager: EventManager
    ) {}
    initUploader(api, broadcast, allowedFileType?, properties?) {
        const attachedFiles = [];
        properties  = properties || {};
        const config: any = {
            isHTML5: true,
            url: api,
            authToken: this.authServerProvider.getToken(),
            maxFileSize: properties.MAX_FILE_SIZE  ?  properties.MAX_FILE_SIZE : environment.MAX_FILE_SIZE,
            autoUpload: true,
            applyOriginalFileName: properties.applyOriginalFileName,
            fileName: properties.applyOriginalFileName ? properties.fileName : '',
            headers: [{
                name: 'x-auth-token',
                value: this.authServerProvider.getToken()
            }]
        };
        if (allowedFileType) {
            config.allowedFileType = allowedFileType;
        }
        const uploader = new FileUploader(config);
        uploader.onBuildItemForm = (fileItem, form)=>{
            var image: any = document.getElementById('fileUpload');
            if (properties.applyOriginalFileName) {
                form.append('applyOriginalFileName ', true);
                form.append('fileName', fileItem.file.name);
            }
            return {fileItem, form}
        };
        uploader.onWhenAddingFileFailed = (item, filter) => {
            this.eventManager.broadcast({
                name: 'close-spinner',
                content: {}
            });
            let message = 'Error Upload';
            switch (filter.name) {
            //   case 'queueLimit':
            //     message = 'Only uploading max ' + environment.MAX_QUEUE_LIMIT + 'files';
            //     break;
              case 'fileSize':
                // tslint:disable-next-line:max-line-length
                message = 'Hình ảnh vượt quá ' + HelperUtil.formatBytes(config.maxFileSize) + ' cho phéo';
                break;
              case 'fileType':
                message = 'Chỉ cho phép các loại sau: ' + (allowedFileType || []).join(', ');
                break;
              default:
                message = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
                break;
            }
            this.eventManager.broadcast({
                name: 'notification',
                content: {
                    type: 'error',
                    title: 'Error Upload',
                    message
                }
            });
        };
        uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.eventManager.broadcast({
                name: 'close-spinner',
                content: {}
            });
            if (this.isErrorUpload) {
                return;
            }
            const res = JSON.parse(response);
            const file = res.data || {};
            let type = 'file';
            if (file.fileName.includes('.doc') || file.fileName.includes('.docx')) {
                type = 'word';
            } else if (file.fileName.includes('.xls') || file.fileName.includes('.xlxs')) {
                type = 'excel';
            } else if (file.fileName.includes('.pdf')) {
                type = 'pdf';
            } else if (file.fileName.includes('.jpg') || file.fileName.includes('.jpeg') || file.fileName.includes('.png') || file.fileName.includes('.gif')) {
                type = 'image';
            }
            file.type = type;
            const exist = attachedFiles.some(item => item.fileName === file.fileName);
            if (exist) {
                this.eventManager.broadcast({
                    name: 'notification',
                    content: {
                        type: 'error',
                        title: 'Error Upload',
                        message: 'File đã tồn tại.'
                    }
                });
                return;
            }
            attachedFiles.push(file);
            this.checkExistUrlImage(broadcast, {
                file: file,
                files: attachedFiles,
                imagePath: file.url
            }, 1)
        };
        uploader.onAfterAddingFile = (item: any) => {
            this.isErrorUpload = false;
        };
        uploader.onBeforeUploadItem = (item: any) => {
            const split = item.file.name.split('.');
            const extension = split.pop();
            const name = split.join('.') + '_' + Date.now() +  '.' + extension;
            item.file.name = name 
            this.isErrorUpload = false;
            this.eventManager.broadcast({
                name: 'show-spinner',
                content: {}
            });
            return item;
        };
        uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.eventManager.broadcast({
                name: 'close-spinner',
                content: {}
            });
            this.isErrorUpload = true;
            if (!response) {
                return;
            }
            const error = JSON.parse(response);
            this.eventManager.broadcast({
                name: 'notification',
                content: {
                    type: 'error',
                    title: 'Error Upload',
                    message: error.detail
                }
            });
        };
        return uploader;
    }
    checkExistUrlImage(broadcast, content, time) {
        const fileUrl = content.file.fileUrl  || content.file.url  || '';
        if (!(fileUrl.includes('png') || fileUrl.includes('jpg') || fileUrl.includes('jpeg'))) {
            this.eventManager.broadcast({
                name: broadcast,
                content
            });
        } else {
            var image = new Image();
            image.src = content.imagePath;
            setTimeout(() =>  {
                if (image.width == 0 && time < 20) {
                    setTimeout(() => {
                        time++;
                        this.checkExistUrlImage(broadcast, content, time);
                    }, 500)
                } else if (image.width > 0) {
                    this.eventManager.broadcast({
                        name: broadcast,
                        content
                    });
                } 
            }, 300) 
        }
        if (time === 20) {
            this.eventManager.broadcast({
                name: 'upload-fail',
                content: {}
            });
            this.eventManager.broadcast({
                name: broadcast + '-upload-fail',
                content: {}
            });
        }
    }
}
// List of allowedFileTypes values:

// application
// image
// video
// audio
// pdf
// compress
// doc
// xls
// ppt